// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetAnnouncement (params?: {}): Promise<List>;
    publicGetAnnouncementUrgent (params?: {}): Promise<List>;
    publicGetChat (params?: {}): Promise<List>;
    publicGetChatChannels (params?: {}): Promise<List>;
    publicGetChatConnected (params?: {}): Promise<Dict>;
    publicGetChatPinned (params?: {}): Promise<Dict>;
    publicGetFunding (params?: {}): Promise<List>;
    publicGetGuild (params?: {}): Promise<List>;
    publicGetInstrument (params?: {}): Promise<List>;
    publicGetInstrumentActive (params?: {}): Promise<List>;
    publicGetInstrumentActiveAndIndices (params?: {}): Promise<List>;
    publicGetInstrumentActiveIntervals (params?: {}): Promise<Dict>;
    publicGetInstrumentCompositeIndex (params?: {}): Promise<List>;
    publicGetInstrumentIndices (params?: {}): Promise<List>;
    publicGetInstrumentUsdVolume (params?: {}): Promise<List>;
    publicGetInsurance (params?: {}): Promise<List>;
    publicGetLeaderboard (params?: {}): Promise<List>;
    publicGetLiquidation (params?: {}): Promise<List>;
    publicGetOrderBookL2 (params?: {}): Promise<List>;
    publicGetPorlNonce (params?: {}): Promise<Dict>;
    publicGetQuote (params?: {}): Promise<List>;
    publicGetQuoteBucketed (params?: {}): Promise<List>;
    publicGetSchema (params?: {}): Promise<Dict>;
    publicGetSchemaWebsocketHelp (params?: {}): Promise<Dict>;
    publicGetSettlement (params?: {}): Promise<List>;
    publicGetStats (params?: {}): Promise<List>;
    publicGetStatsHistory (params?: {}): Promise<List>;
    publicGetStatsHistoryUSD (params?: {}): Promise<List>;
    publicGetTrade (params?: {}): Promise<List>;
    publicGetTradeBucketed (params?: {}): Promise<List>;
    publicGetWalletAssets (params?: {}): Promise<List>;
    publicGetWalletCurrencies (params?: {}): Promise<Dict>;
    publicGetWalletHaircuts (params?: {}): Promise<List>;
    publicGetWalletNetworks (params?: {}): Promise<List>;
    privateGetAddress (params?: {}): Promise<List>;
    privateGetAddressConfig (params?: {}): Promise<Dict>;
    privateGetApiKey (params?: {}): Promise<List>;
    privateGetApiKeySelf (params?: {}): Promise<Dict>;
    privateGetExecution (params?: {}): Promise<List>;
    privateGetExecutionTradeHistory (params?: {}): Promise<List>;
    privateGetGlobalNotification (params?: {}): Promise<List>;
    privateGetLeaderboardName (params?: {}): Promise<Dict>;
    privateGetLeagueoftraderMyRankings (params?: {}): Promise<List>;
    privateGetManagedSubAccountBindingInvestor (params?: {}): Promise<List>;
    privateGetManagedSubAccountBindingTradingTeam (params?: {}): Promise<List>;
    privateGetOrder (params?: {}): Promise<List>;
    privateGetPorlSnapshots (params?: {}): Promise<List>;
    privateGetPosition (params?: {}): Promise<List>;
    privateGetReferralCode (params?: {}): Promise<List>;
    privateGetReferralCodeCheckCode (params?: {}): Promise<Dict>;
    privateGetReferralCodeCodeCode (params?: {}): Promise<Dict>;
    privateGetReferralCodeId (params?: {}): Promise<Dict>;
    privateGetUser (params?: {}): Promise<Dict>;
    privateGetUserAffiliateStatus (params?: {}): Promise<Dict>;
    privateGetUserCheckReferralCode (params?: {}): Promise<Dict>;
    privateGetUserCommission (params?: {}): Promise<Dict>;
    privateGetUserCsa (params?: {}): Promise<Dict>;
    privateGetUserDepositAddress (params?: {}): Promise<string>;
    privateGetUserDepositAddressInformation (params?: {}): Promise<Dict>;
    privateGetUserExecutionHistory (params?: {}): Promise<List>;
    privateGetUserGetWalletTransferAccounts (params?: {}): Promise<List>;
    privateGetUserMargin (params?: {}): Promise<Dict>;
    privateGetUserMarginingMode (params?: {}): Promise<Dict>;
    privateGetUserQuoteFillRatio (params?: {}): Promise<Dict>;
    privateGetUserQuoteValueRatio (params?: {}): Promise<Dict>;
    privateGetUserStaking (params?: {}): Promise<List>;
    privateGetUserStakingInstruments (params?: {}): Promise<List>;
    privateGetUserStakingTiers (params?: {}): Promise<Dict>;
    privateGetUserTradingSettings (params?: {}): Promise<Dict>;
    privateGetUserTradingVolume (params?: {}): Promise<List>;
    privateGetUserUnstakingRequests (params?: {}): Promise<List>;
    privateGetUserWallet (params?: {}): Promise<Dict>;
    privateGetUserWalletHistory (params?: {}): Promise<List>;
    privateGetUserWalletSummary (params?: {}): Promise<List>;
    privateGetUserAffiliates (params?: {}): Promise<List>;
    privateGetUserEvent (params?: {}): Promise<List>;
    privateGetUserPriceAlert (params?: {}): Promise<List>;
    privateGetUserStatsVolumeRank (params?: {}): Promise<Dict>;
    privatePostAddress (params?: {}): Promise<Dict>;
    privatePostChat (params?: {}): Promise<Dict>;
    privatePostGuild (params?: {}): Promise<Dict>;
    privatePostGuildArchive (params?: {}): Promise<Dict>;
    privatePostGuildJoin (params?: {}): Promise<Dict>;
    privatePostGuildKick (params?: {}): Promise<Dict>;
    privatePostGuildLeave (params?: {}): Promise<Dict>;
    privatePostGuildSharesTrades (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingApprove (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingCancel (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingCreateMSA (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingReject (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingToggleTradeHistory (params?: {}): Promise<Dict>;
    privatePostManagedSubAccountBindingUnbind (params?: {}): Promise<Dict>;
    privatePostOrder (params?: {}): Promise<Dict>;
    privatePostOrderCancelAllAfter (params?: {}): Promise<Dict>;
    privatePostOrderClosePosition (params?: {}): Promise<Dict>;
    privatePostPositionCrossLeverage (params?: {}): Promise<Dict>;
    privatePostPositionIsolate (params?: {}): Promise<Dict>;
    privatePostPositionLeverage (params?: {}): Promise<Dict>;
    privatePostPositionRiskLimit (params?: {}): Promise<Dict>;
    privatePostPositionTransferMargin (params?: {}): Promise<Dict>;
    privatePostReferralCode (params?: {}): Promise<Dict>;
    privatePostUserAddSubaccount (params?: {}): Promise<Dict>;
    privatePostUserCancelWithdrawal (params?: {}): Promise<Dict>;
    privatePostUserCommunicationToken (params?: {}): Promise<string>;
    privatePostUserConfirmEmail (params?: {}): Promise<Dict>;
    privatePostUserConfirmWithdrawal (params?: {}): Promise<Dict>;
    privatePostUserCreateIndependentSubaccount (params?: {}): Promise<Dict>;
    privatePostUserLogout (params?: {}): Promise<string>;
    privatePostUserMarginingMode (params?: {}): Promise<Dict>;
    privatePostUserPositionMode (params?: {}): Promise<Dict>;
    privatePostUserPreferences (params?: {}): Promise<Dict>;
    privatePostUserRequestWithdrawal (params?: {}): Promise<Dict>;
    privatePostUserUnstakingRequests (params?: {}): Promise<Dict>;
    privatePostUserUpdateSubaccount (params?: {}): Promise<Dict>;
    privatePostUserWalletTransfer (params?: {}): Promise<Dict>;
    privatePostUserPriceAlert (params?: {}): Promise<Dict>;
    privatePutAddress (params?: {}): Promise<Dict>;
    privatePutGuild (params?: {}): Promise<Dict>;
    privatePutOrder (params?: {}): Promise<Dict>;
    privatePutReferralCodeId (params?: {}): Promise<Dict>;
    privatePutUserPriceAlertId (params?: {}): Promise<Dict>;
    privateDeleteOrder (params?: {}): Promise<List>;
    privateDeleteOrderAll (params?: {}): Promise<List>;
    privateDeleteReferralCodeId (params?: {}): Promise<Dict>;
    privateDeleteUserUnstakingRequests (params?: {}): Promise<Dict>;
    privateDeleteUserWithdrawal (params?: {}): Promise<Dict>;
    privateDeleteUserPriceAlert (params?: {}): Promise<Dict>;
    privateDeleteUserPriceAlertId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
